// Penanda perangkat (browser ini) untuk layar pelanggan: server memisahkan sesi layar per akun DAN per perangkat, jadi akun
// kasir yang sama di web dan di aplikasi (atau di dua komputer) masing-masing punya kode dan layar sendiri.
// Disimpan di localStorage (satu penanda per profil browser; tab yang sama browsernya berbagi layar, itu wajar).
const KUNCI = 'perangkatId';
const POLA = /^[A-Za-z0-9_-]{8,64}$/;

const acak = (panjang = 20) => {
  const huruf = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const bytes = new Uint8Array(panjang);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (let i = 0; i < panjang; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  return Array.from(bytes, (b) => huruf[b % huruf.length]).join('');
};

let sementara = null; // bila localStorage diblokir: penanda hanya berlaku selama halaman terbuka

/** Penanda perangkat ini (dibuat sekali, lalu tetap). */
export const idPerangkat = () => {
  try {
    const ada = window.localStorage.getItem(KUNCI);
    if (ada && POLA.test(ada)) return ada;
    const baru = `web-${acak(20)}`;
    window.localStorage.setItem(KUNCI, baru);
    return baru;
  } catch (e) {
    if (!sementara) sementara = `web-${acak(20)}`;
    return sementara;
  }
};
